import { axiosInstance } from "lib/axios";
import { authAPI } from "services/apis.service";

export const updateAvatar = async (avatarSchema, avatarConfigJson) => {
  const flatConfig = Object.fromEntries(
    Object.entries(avatarConfigJson).map(([key, val]) => [
      key,
      Array.isArray(val) ? val[0] : val,
    ])
  );

  const payload = {
    avatarSchema,
    avatarConfigJson: flatConfig,
  };
  const { data } = await axiosInstance.post(authAPI.addUpdateAvatar, payload);
  return data;
};
